// import {initializeApp} from "firebase/app";
// import {getAuth} from 'firebase/auth';
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: "AIzaSyCZX36qjj48b4vBsly1tzXAfzPvyILChqw",
//     authDomain: "fibre-shop.firebaseapp.com",
//     projectId: "fibre-shop",
//     storageBucket: "fibre-shop.appspot.com",
//     messagingSenderId: "364748189554",
//     appId: "1:364748189554:web:76d7ccfcf5605e021637eb",
//     measurementId: "G-XD7DX0CZ9P"
//   };

//   const firebaseApp = initializeApp(firebaseConfig);
//   // export const db = firebaseApp.firestore();
//   // const auth = firebase.auth();
//   export const auth = getAuth(firebaseApp);

//   // Import the functions you need from the SDKs you need
// // import { initializeApp } from "firebase/app";
// // import { getAnalytics } from "firebase/analytics";
// // import { getAuth } from "firebase/auth";
// // // TODO: Add SDKs for Firebase products that you want to use
// // // https://firebase.google.com/docs/web/setup#available-libraries

// // // Your web app's Firebase configuration
// // // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// // const firebaseConfig = {
// //   apiKey: "AIzaSyCZX36qjj48b4vBsly1tzXAfzPvyILChqw",
// //   authDomain: "fibre-shop.firebaseapp.com",
// //   projectId: "fibre-shop",
// //   storageBucket: "fibre-shop.appspot.com",
// //   messagingSenderId: "364748189554",
// //   appId: "1:364748189554:web:76d7ccfcf5605e021637eb",
// //   measurementId: "G-XD7DX0CZ9P"
// // };

// // // Initialize Firebase
// // const app = initializeApp(firebaseConfig);
// // export const auth = getAuth(app);
// // const analytics = getAnalytics(app);

import { initializeApp } from "firebase/app";
import { browserSessionPersistence, getAuth, setPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCZX36qjj48b4vBsly1tzXAfzPvyILChqw",
  authDomain: "fibre-shop.firebaseapp.com",
  projectId: "fibre-shop",
  storageBucket: "fibre-shop.appspot.com",
  messagingSenderId: "364748189554",
  appId: "1:364748189554:web:76d7ccfcf5605e021637eb",
  measurementId: "G-XD7DX0CZ9P"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence);
export default app;